import React from 'react';
import PropTypes from 'prop-types';

import ListCategories from 'components/ListCategories/ListCategories';

const NotificationSettingViewController = (props) => {
  const { formatText, configuration, handleControllers } = props;

  return (
    <div className="settings-notification-view col-xs-12 col-md-12">
      <ListCategories
        formatText={formatText}
        showProducts
        configuration={configuration}
        handleControllers={handleControllers()}
      />
    </div>
  );
};

NotificationSettingViewController.propTypes = {
  successCallBack: PropTypes.func.isRequired,
  configuration: PropTypes.obj,
  formatText: PropTypes.func.isRequired,
};


NotificationSettingViewController.defaultProps = {
  configuration: {},
};

export default NotificationSettingViewController;
